import { makeServicesTypes } from '@/core/container/makeServicesTypes'
import { enumKeysToArray } from '@/utils/enum'

export enum LABELS_SERVICES {
  LabelService,
  LabelRepository,
  AddLabelFormService,
}

export type LabelsServices = keyof typeof LABELS_SERVICES

export const LABELS_SERVICES_TYPES: Record<LabelsServices, symbol> = makeServicesTypes<LabelsServices>(
  enumKeysToArray<LabelsServices>(LABELS_SERVICES),
)
